export default [
  {
    path: '/main/financial/vehicles',
    meta: {
      tag: 'list_financial_vehicles',
      name: 'Veículos (Financeiro)',
      breadcrumb: 'Veículos (Financeiro)'
    },
    component: () => import(/* webpackChunkName: "financial-vehicles-list" */ '@/views/main/settings/financial/vehicle/Index.vue'),
    children: [
      {
        path: '',
        name: 'listfinancialvehicle',
        meta: {
          tag: 'list_financial_vehicles',
          menu: 'settings',
          name: 'Veículos (Financeiro)'
        },
        component: () => import(/* webpackChunkName: "financial-vehicles-list" */ '@/views/main/settings/financial/vehicle/List.vue'),
      },
      {
        path: '/main/financial/vehicle/add',
        name: 'addfinancialvehicle',
        meta: {
          tag: 'add_financial_vehicle',
          menu: 'settings',
          name: 'Adicionar | Veículo (Financeiro)',
          breadcrumb: 'Adicionar Veículo (Financeiro)'
        },
        component: () => import(/* webpackChunkName: "financial-vehicle-add" */ '@/views/main/settings/financial/vehicle/Add.vue')
      },
      {
        path: '/main/financial/vehicle/:id',
        name: 'editfinancialvehicle',
        meta: {
          tag: 'edit_financial_vehicle',
          menu: 'settings',
          name: 'Editar | Veículo (Financeiro)',
          breadcrumb: 'Editar Veículo (Financeiro)'
        },
        component: () => import(/* webpackChunkName: "financial-vehicle-edit" */ '@/views/main/settings/financial/vehicle/Edit.vue')
      }
    ]
  }
]
